import { DataGrid } from "@material-ui/data-grid";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { makeStyles } from "@material-ui/core/styles";

const columns = [
  { field: "email", headerName: "E-Mail", width: 180 },
  { field: "name", headerName: "Name", width: 180 },
  { field: "company", headerName: "Company", width: 200 },
  {
    field: "licensesCount",
    headerName: "Total Licenses",
    width: 150,
  },
];

const useStyles = makeStyles((theme) => ({
  buttonsSpacing: {
    margin: theme.spacing(1),
  },
  grid: {
    background: "white",
  },
  titleMargin: {
    margin: theme.spacing(1, 0, 4, 0),
  },
}));

const CustomersList = (props) => {
  const classes = useStyles();

  return (
    <>
      <Typography gutterBottom variant="h5" className={classes.titleMargin}>
        Customers
      </Typography>
      <div style={{ height: 350 }}>
        <DataGrid
          className={classes.grid}
          loading={props.isLoading}
          rows={props.rows}
          columns={columns}
          onRowSelected={props.onRowSelected}
        />
      </div>
      <Grid container direction="row" justify="flex-end" alignItems="center">
        <IconButton
          aria-label="add"
          color="primary"
          disabled={props.isAddDisabled}
          onClick={props.onAdd}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          aria-label="edit"
          color="primary"
          disabled={props.selectedId === null}
          onClick={props.onEdit}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="delete"
          color="secondary"
          disabled={props.selectedId === null}
          onClick={props.onDelete}
        >
          <DeleteIcon />
        </IconButton>        
      </Grid>
    </>
  );
};

export default CustomersList;
